export type MobileOS = 'ios' | 'android'

export function getMobileOS(): MobileOS | undefined {
  if (typeof navigator === 'undefined') return undefined
  const ua = navigator.userAgent
  if (/android/i.test(ua)) return 'android'
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios'
  if (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios'
  return undefined
}
